import script from "./FrameGames.vue?vue&type=script&setup=true&lang=js"
export * from "./FrameGames.vue?vue&type=script&setup=true&lang=js"

import "./FrameGames.vue?vue&type=style&index=0&id=8085338e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8085338e"]])

export default __exports__